import { render, staticRenderFns } from "./ListaServiciosByAdmin.vue?vue&type=template&id=46f49c10"
import script from "./ListaServiciosByAdmin.vue?vue&type=script&lang=js"
export * from "./ListaServiciosByAdmin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports